import { render, staticRenderFns } from "./ChatSearchPicture.vue?vue&type=template&id=378697a3&scoped=true"
import script from "./ChatSearchPicture.vue?vue&type=script&lang=js"
export * from "./ChatSearchPicture.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "378697a3",
  null
  
)

export default component.exports